/* Ceneo category mapping tool — populates the Ceneo-category datalist, validates
   entries and generates the paste-ready snippets/ceneo-category-map.liquid content.
   No theme dependencies. */
(function () {
  var root = document.querySelector('[data-ceneo-mapping]');
  if (!root) return;

  var datalist = document.getElementById('ceneo-cats');
  var output = root.querySelector('[data-ceneo-output]');
  var generateBtn = root.querySelector('[data-ceneo-generate]');
  var workerOutput = root.querySelector('[data-ceneo-output-worker]');
  var workerBtn = root.querySelector('[data-ceneo-generate-worker]');
  var statusEl = root.querySelector('[data-ceneo-status]');
  var known = new Set();

  function setStatus(msg) {
    if (statusEl) statusEl.textContent = msg || '';
  }

  // --- Access gate: light protection. The password is never in the page; Liquid
  // renders only its sha256, and we compare hashes client-side. Fails closed
  // (body starts hidden when a password is set, revealed only on a correct hash). ---
  (function () {
    var gateHash = (root.getAttribute('data-gate-hash') || '').trim();
    if (!gateHash) return; // no password configured — tool is open
    var gateForm = root.querySelector('[data-ceneo-gate-form]');
    var body = root.querySelector('[data-ceneo-body]');
    var input = root.querySelector('[data-ceneo-gate-input]');
    var msg = root.querySelector('[data-ceneo-gate-msg]');
    var STORAGE_KEY = 'ceneo-mapping-unlocked';

    function unlock() { if (gateForm) gateForm.hidden = true; if (body) body.hidden = false; }
    function lock() { if (body) body.hidden = true; if (gateForm) gateForm.hidden = false; }

    function sha256Hex(str) {
      var bytes = new TextEncoder().encode(str);
      return crypto.subtle.digest('SHA-256', bytes).then(function (buf) {
        var arr = new Uint8Array(buf);
        var hex = '';
        for (var i = 0; i < arr.length; i++) hex += arr[i].toString(16).padStart(2, '0');
        return hex;
      });
    }

    try {
      if (localStorage.getItem(STORAGE_KEY) === gateHash) { unlock(); return; }
    } catch (e) {}

    lock();
    if (gateForm) {
      gateForm.addEventListener('submit', function (e) {
        e.preventDefault();
        sha256Hex(input ? input.value : '').then(function (h) {
          if (h === gateHash) {
            try { localStorage.setItem(STORAGE_KEY, gateHash); } catch (e) {}
            if (msg) msg.textContent = '';
            unlock();
          } else if (msg) {
            msg.textContent = 'Nieprawidłowe hasło.';
          }
        });
      });
    }
  })();

  // Load the official Ceneo category list into the shared datalist.
  fetch(root.getAttribute('data-categories-url'))
    .then(function (r) { return r.json(); })
    .then(function (paths) {
      var frag = document.createDocumentFragment();
      paths.forEach(function (p) {
        known.add(p);
        var opt = document.createElement('option');
        opt.value = p;
        frag.appendChild(opt);
      });
      if (datalist) datalist.appendChild(frag);
      refreshAll();
      setStatus(paths.length + ' kategorii Ceneo wczytanych.');
    })
    .catch(function () {
      setStatus('Nie udało się wczytać listy kategorii Ceneo (ceneo-categories.json).');
    });

  function classifyInput(input) {
    var v = input.value.trim();
    input.classList.toggle('is-set', v !== '' && known.has(v));
    input.classList.toggle('is-unknown', v !== '' && !known.has(v));
  }

  function refreshAll() {
    root.querySelectorAll('.ceneo-mapping__input').forEach(classifyInput);
  }

  root.addEventListener('input', function (e) {
    if (e.target.classList.contains('ceneo-mapping__input')) classifyInput(e.target);
  });

  // Liquid double-quoted string literals can't contain a double quote; drop any.
  function lit(s) {
    return s.replace(/"/g, '');
  }

  function buildSnippet() {
    var lines = [];
    var count = 0;
    var unknown = 0;
    root.querySelectorAll('.ceneo-mapping__input').forEach(function (input) {
      var shop = (input.getAttribute('data-shop-category') || '').trim();
      var ceneo = input.value.trim();
      if (!shop || !ceneo) return;
      if (!known.has(ceneo)) unknown++;
      lines.push('    when "' + lit(shop) + '"');
      lines.push('      echo "' + lit(ceneo) + '"');
      count++;
    });

    var body = lines.length ? lines.join('\n') : '    # (no mappings set)';
    var snippet =
      '{%- comment -%}\n' +
      '  Ceneo category map — generated by the Ceneo mapping page (page.ceneo-mapping).\n' +
      '  To change: open that page, adjust the categories, click "Skopiuj mapowanie" and\n' +
      '  paste the result over this entire file.\n' +
      '  KEY = full Shopify taxonomy path (ceneo-category-path.liquid); VALUE = Ceneo path.\n' +
      '{%- endcomment -%}\n' +
      '{%- liquid\n' +
      '  case category\n' +
      body + '\n' +
      '    else\n' +
      "      echo ''\n" +
      '  endcase\n' +
      '-%}\n';

    return { text: snippet, count: count, unknown: unknown };
  }

  // Build the ID-keyed CATEGORY_MAP_BY_ID object for ceneo-worker.js (the live feed).
  // Keyed on the taxonomy id (language-independent) so it matches the Admin API,
  // which returns category names in English for the Worker's token.
  function buildWorkerMap() {
    var lines = [];
    var count = 0;
    var unknown = 0;
    root.querySelectorAll('.ceneo-mapping__input').forEach(function (input) {
      var id = (input.getAttribute('data-category-id') || '').trim();
      var shop = (input.getAttribute('data-shop-category') || '').trim();
      var ceneo = input.value.trim();
      if (!id || !ceneo) return;
      if (!known.has(ceneo)) unknown++;
      var leaf = shop.split('>').pop().trim(); // Polish path uses " > " separators
      lines.push('  ' + JSON.stringify(id) + ': ' + JSON.stringify(ceneo) + ',' + (leaf ? ' // ' + leaf : ''));
      count++;
    });

    var body = lines.length ? lines.join('\n') : '  // (no mappings set)';
    var text =
      '// Shopify taxonomy category id  ->  Ceneo path. Generated by the Ceneo mapping page.\n' +
      'const CATEGORY_MAP_BY_ID = {\n' +
      body + '\n' +
      '};\n';

    return { text: text, count: count, unknown: unknown };
  }

  function copyResult(text, outputEl, baseMsg) {
    if (outputEl) outputEl.value = text;
    var done = function () { setStatus(baseMsg + ' Skopiowano do schowka.'); };
    var fallback = function () {
      if (outputEl) { outputEl.focus(); outputEl.select(); }
      setStatus(baseMsg + ' Zaznacz pole poniżej i skopiuj (Ctrl+C).');
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, fallback);
    } else {
      fallback();
    }
  }

  function statusFor(result, label) {
    var msg = result.count + ' mapowań (' + label + ')';
    if (result.unknown) msg += ' — ' + result.unknown + ' spoza listy Ceneo, sprawdź podświetlone pola';
    return msg + '.';
  }

  if (workerBtn) {
    workerBtn.addEventListener('click', function () {
      var result = buildWorkerMap();
      copyResult(result.text, workerOutput, statusFor(result, 'Worker'));
    });
  }

  generateBtn.addEventListener('click', function () {
    var result = buildSnippet();
    copyResult(result.text, output, statusFor(result, 'Liquid'));
  });
})();
